<script setup lang="ts">
  import { ref } from 'vue';
  import {
    ModalSkeleton,
    ModalTitle,
    ModalActions,
    ModalContent,
    useModal,
  } from '@tundr/modal';
  import { useLogout } from '@shared/composables/use-logout.ts';
  import TermsModal from '../TermsModal/TermsModal.vue';
  import { Checkbox, ExternalLink } from '@tundr/ds-components';
  import {
    privacyContentClass,
    privacyLinkClass,
  } from './PrivacyModalClass.css';
  import { useLocale } from '@tundr/i18n';
  import { ENV_VARS } from '@core/config/env';

  const { t } = useLocale('serviceAgreements');
  const { openModal, closeModal } = useModal();
  const { onLogout } = useLogout();

  const accepted = ref<boolean>(false);

  const onConfirm = () => {
    openModal({
      component: TermsModal,
    });
  };

  const onCancel = () => {
    closeModal();

    // fix ugly ui behaviour
    setTimeout(() => {
      onLogout();
    }, 150);
  };

  const privacyDocumentUrl = ENV_VARS.serviceAgreements.privacy;
</script>

<template>
  <ModalSkeleton>
    <template #title>
      <ModalTitle>{{ t('privacy.modal_title') }}</ModalTitle>
    </template>
    <ModalContent>
      <div :class="privacyContentClass">
        <Checkbox
          v-model="accepted"
          name="privacy"
          multiline
          :label="t('privacy.checkbox_label')"
        />
        <ExternalLink
          v-if="privacyDocumentUrl"
          :title="t('privacy.link_text')"
          :href="privacyDocumentUrl"
          :class="privacyLinkClass"
        >
          {{ t('privacy.link_text') }}
        </ExternalLink>
      </div>
    </ModalContent>
    <template #actions>
      <ModalActions
        :confirm-label="t('common:actions.confirm')"
        :confirm-test-id="'confirm-privacy-modal-button'"
        :disable-confirm="!accepted"
        @confirm="onConfirm"
        @cancel="onCancel"
        :cancel-label="t('common:actions.cancel')"
      />
    </template>
  </ModalSkeleton>
</template>
